import { render, staticRenderFns } from "./ElementsIndex.vue?vue&type=template&id=46e944e6"
import script from "./ElementsIndex.vue?vue&type=script&lang=js"
export * from "./ElementsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports